import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Spinner } from "@fluentui/react-components";
import { useStyles } from "./styles/HomeLoginComponent.styles";

export const HomeLoginComponent = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const styles = useStyles();

    useEffect(() => {
        if (isLoggedIn && window.location.pathname === "/") {
            setIsLoading(true);
            navigate("/containers");
        }
    }, [isLoggedIn, navigate]);

    if (window.location.pathname !== "/") {
        return null;
    }

    if (isLoading) {
        return (<div className={styles.overlay}>
            <Spinner size="large" label="Loading..." />
        </div> );
    }

    return null;
};
